import React from "react";
import { Button, Space, Popconfirm } from "antd";
import { EditOutlined, CopyOutlined, DeleteOutlined } from "@ant-design/icons";
import { Tariff } from "../utils/types";

interface TariffActionButtonsProps {
  tariff: Tariff;
  onEdit: (tariff: Tariff) => void;
  onDuplicate: (tariff: Tariff) => void;
  onDelete: (id: number) => void;
}

const TariffActionButtons: React.FC<TariffActionButtonsProps> = ({
  tariff,
  onEdit,
  onDuplicate,
  onDelete,
}) => {
  return (
    <Space>
      <Button
        type="text"
        icon={<EditOutlined />}
        onClick={() => onEdit(tariff)}
        title="Edit"
      />
      <Button
        type="text"
        icon={<CopyOutlined />}
        onClick={() => onDuplicate(tariff)}
        title="Duplicate"
      />
      <Popconfirm
        title="Delete this tariff?"
        description="Are you sure you want to delete this tariff? This action cannot be undone."
        onConfirm={() => onDelete(tariff.id)}
        okText="Yes"
        cancelText="No"
      >
        <Button type="text" danger icon={<DeleteOutlined />} title="Delete" />
      </Popconfirm>
    </Space>
  );
};

export default TariffActionButtons;
